// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Header from '../Header';
import Footer from '../Footer';
import MenuCompany from '../MenuContentCompany';
import MenuWorkShop from '../MenuContentWorkShop';

// Style
import '../../../css/app.css';

function Template({
  children,
  type,
  className,
  classNameContainer,
  footerComponent = undefined,
  headerComponent = undefined,
  newMaintenances,
}) {
  switch (type) {
    case 1:
      return (
        <div className="root">
          <div className="wrapper">
            <Header>{headerComponent}</Header>
            {children}
            <Footer>{footerComponent}</Footer>
          </div>
        </div>
      );
    case 2:
      return (
        <div className="root">
          <div className="wrapper">
            <div className="content_menu">
              <div className={classNameContainer}>
                <Header> {headerComponent} </Header>
              </div>
            </div>
            <div className={className}>{children}</div>
            <Footer>{footerComponent}</Footer>
          </div>
        </div>
      );
    case 3:
      return (
        <div className="root">
          <div className="wrapper">
            <div className="content_menu content_menu_internal">
              <div className={classNameContainer}>
                <Header newMaintenances={newMaintenances} type={1}>
                  {' '}
                  {headerComponent}{' '}
                </Header>
              </div>
            </div>

            <div className={className}>
              <div className="row no-gutters">
                <MenuWorkShop newMaintenances={newMaintenances}> {children} </MenuWorkShop>
              </div>
            </div>
          </div>
        </div>
      );
    case 4:
      return (
        <div className="root">
          <div className="wrapper">
            <div className="content_menu content_menu_internal">
              <div className={classNameContainer}>
                <Header newMaintenances={newMaintenances} type={2}>
                  {' '}
                  {headerComponent}{' '}
                </Header>
              </div>
            </div>

            <div className={className}>
              <div className="row no-gutters">
                <MenuCompany newMaintenances={newMaintenances}> {children} </MenuCompany>
              </div>
            </div>
          </div>
        </div>
      );
    default:
      return (
        <div className="root">
          <div className="wrapper">
            <Header>{headerComponent}</Header>
            {children}
            <Footer>{footerComponent}</Footer>
          </div>
        </div>
      );
  }
}

Template.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.number.isRequired,
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  footerComponent: PropTypes.elementType,
  headerComponent: PropTypes.elementType,
  newMaintenances: PropTypes.number,
};

Template.defaultProps = {
  className: '',
  classNameContainer: '',
  footerComponent: undefined,
  headerComponent: undefined,
  newMaintenances: -1,
};

export default Template;
